import React from "react";
import { BottomSheet } from "./BottomSheet.jsx";
import { Button } from "./Button.jsx";

/**
 * Shown instead of a bill that belongs to another company (opened from a link, ledger row, bank match…).
 * Only the header company's bills are viewed or edited, so the user switches company or goes back.
 */
export function OtherCompanyPrompt({ isOpen, kind = "invoice", billNo = "", company, onSwitch, onCancel }) {
  if (!isOpen || !company) return null;
  return (
    <BottomSheet isOpen onClose={onCancel} title="🏢 Another company's bill">
      <div data-testid="other-company-prompt" style={{ fontSize: "0.92rem", lineHeight: 1.5, marginBottom: "1rem" }}>
        This {kind}{billNo ? <> <strong>{billNo}</strong></> : ""} belongs to <strong>{company.name}</strong>.
        <div style={{ fontSize: "0.8rem", color: "var(--text-dim)", marginTop: "0.35rem" }}>
          You can only open the bills of the company selected in the header.
        </div>
      </div>
      <div style={{ display: "flex", gap: "0.5rem" }}>
        <Button variant="secondary" block onClick={onCancel}>Cancel</Button>
        <Button variant="primary" block onClick={onSwitch}>Switch to {company.name}</Button>
      </div>
    </BottomSheet>
  );
}

export default OtherCompanyPrompt;
